import { NgModule } from '@angular/core';
import {CommonModule, NgOptimizedImage} from '@angular/common';

import { VmsSubmittalRoutingModule } from './vms-submittal-routing.module';
import { VmsSubmittalContainerComponent } from './vms-submittal-container/vms-submittal-container.component';
import { VmsSubmittalRightToRepresentComponent} from "./vms-submittal-right-to-represent/vms-submittal-right-to-represent.component";
import { TranslateModule } from "@ngx-translate/core";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {MatFormFieldModule, MatLabel} from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import {MatProgressBarModule} from "@angular/material/progress-bar";
import {MatButton, MatButtonModule} from "@angular/material/button";
import {MatCard, MatCardContent, MatCardHeader} from "@angular/material/card";
import {MatCheckbox} from "@angular/material/checkbox";
import {MatIcon} from "@angular/material/icon";
import {MatProgressSpinner} from "@angular/material/progress-spinner";
import {AngularSvgIconModule} from "angular-svg-icon";
import {InitialInterviewModule} from "../initial-interview/initial-interview.module";
import { VmsSubmittalEmploymentHistoryAndRelationshipComponent } from "./vms-submittal-employment-history-and-relationship/vms-submittal-employment-history-and-relationship.component";
import { MatRadioButton, MatRadioGroup } from "@angular/material/radio";
import { MatChipListbox, MatChipOption } from "@angular/material/chips";
import {
  VmsSubmittalCandidateValidationComponent
} from "./vms-submittal-candidate-validation/vms-submittal-candidate-validation.component";
import { DatePickerComponent } from '../shared/components/date-picker/date-picker.component';
import {MatSelectModule} from '@angular/material/select';
import {MatListModule} from '@angular/material/list';
import {DateRangePickerComponent} from '../shared/components/date-range-picker/date-range-picker.component';
import { MatExpansionModule } from "@angular/material/expansion";

@NgModule({
  declarations: [
    VmsSubmittalContainerComponent,
    VmsSubmittalRightToRepresentComponent,
    VmsSubmittalEmploymentHistoryAndRelationshipComponent,
    VmsSubmittalCandidateValidationComponent
  ],
  imports: [
    MatProgressBarModule,
    MatButton,
    MatCard,
    MatCardContent,
    MatCardHeader,
    MatCheckbox,
    FormsModule,
    MatFormFieldModule,
    MatIcon,
    MatButtonModule,
    MatLabel,
    MatProgressSpinner,
    AngularSvgIconModule.forRoot(),
    CommonModule,
    VmsSubmittalRoutingModule,
    TranslateModule,
    ReactiveFormsModule,
    MatInputModule,
    InitialInterviewModule,
    MatRadioGroup,
    MatRadioButton,
    MatChipListbox,
    MatChipOption,
    DatePickerComponent,
    DateRangePickerComponent,
    MatSelectModule,
    NgOptimizedImage,
    MatListModule,
    MatExpansionModule
  ]
})
export class VmsSubmittalModule { }
